module.exports = __webpack_public_path__ + "static/media/back-arrow-header.7281cc84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/back-arrow-header.svg
// module id = 286
// module chunks = 0